<template>
    <div class="status" :class="`variant-${variant}`">
        <span
            ><img v-if="iconSrc" :src="iconSrc" /><span v-if="text">{{ text }}</span></span
        >
    </div>
</template>
<script setup lang="ts">
    import { computed } from "vue";

    const props = withDefaults(
        defineProps<{
            text?: string;
            // Boolean för att även kunna användas vid preliminarbokning true, vilket inte är en status
            // men ska visas på liknande sätt
            status: string | boolean;
            icons: { [index: string]: any };
            variant?: "default" | "small";
        }>(),
        {
            text: "",
            variant: "default",
        }
    );

    const iconSrc = computed(() => props.icons[props.status as keyof typeof props.icons]);
</script>
<style lang="scss" scoped>
    @import "@/style/_variables.scss";

    .status {
        display: flex;
        align-items: center;

        font-weight: 400;
        > span {
            display: flex;
        }

        img {
            margin-right: $icon-margin-small;
            position: relative;
            top: -1px;
        }

        &.variant-default {
            font-size: 14px;
        }
        &.variant-small {
            font-size: 13px;

            > span img {
                width: 16px;
            }
        }

        span span {
            white-space: nowrap;
        }
    }
</style>
